<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container>
      <q-page class="flex flex-center bg-gradient">
        <div class="login-container">
          <!-- Logo e Título -->
          <div class="text-center q-mb-xl">
            <q-icon size="110px">
              <img src="../assets/icon2.png" alt="">
            </q-icon>
            <h4 class="text-h4 text-weight-bold q-mb-sm q-mt-none">Bem-vindo de volta</h4>
            <p class="text-grey-7">Faça login para acessar sua conta</p>
          </div>

          <!-- Card de Login -->
          <q-card class="login-card q-pa-lg shadow-10">
            <q-card-section>
              <q-form @submit="handleLogin" class="q-gutter-md">
                <!-- Campo Email -->
                <q-input
                  v-model="form.email"
                  type="email"
                  label="Email"
                  outlined
                  :rules="[
                    val => !!val || 'Email é obrigatório',
                    val => /.+@.+\..+/.test(val) || 'Email inválido'
                  ]"
                  lazy-rules
                  :error="!!errors.email"
                  :error-message="errors.email"
                >
                  <template v-slot:prepend>
                    <q-icon name="mail" />
                  </template>
                </q-input>

                <!-- Campo Senha -->
                <q-input
                  v-model="form.password"
                  :type="showPassword ? 'text' : 'password'"
                  label="Senha"
                  outlined
                  :rules="[
                    val => !!val || 'Senha é obrigatória',
                    val => val.length >= 6 || 'Senha deve ter no mínimo 6 caracteres'
                  ]"
                  lazy-rules
                  :error="!!errors.password"
                  :error-message="errors.password"
                >
                  <template v-slot:prepend>
                    <q-icon name="lock" />
                  </template>
                  <template v-slot:append>
                    <q-icon
                      :name="showPassword ? 'visibility_off' : 'visibility'"
                      class="cursor-pointer"
                      @click="showPassword = !showPassword"
                    />
                  </template>
                </q-input>

                <!-- Lembrar-me e Esqueci senha -->
                <div class="row items-center justify-between">
                  <q-checkbox v-model="rememberMe" label="Lembrar-me" />
                  <q-btn
                    flat
                    dense
                    color="primary"
                    label="Esqueceu a senha?"
                    @click="handleForgotPassword"
                    class="text-caption"
                  />
                </div>

                <!-- Botão Submit -->
                <q-btn
                  type="submit"
                  color="primary"
                  label="Entrar"
                  :loading="loading"
                  unelevated
                  size="lg"
                  class="full-width q-mt-md"
                  icon-right="arrow_forward"
                />
                <q-btn
                outline 
                rounded 
                color="primary"
                :loading="loading"
                unelevated
                size="md"
                class="full-width q-mt-sm"
                @click="loginWithGoogle"
              >
                <template v-slot:default>
                  <div class="row items-center no-wrap full-width justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 48 48" class="q-mr-sm">
                      <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
                      <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/>
                      <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/>
                      <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/>
                    </svg>
                    <span>Entrar com Google</span>
                  </div>
                </template>
              </q-btn>
              </q-form>
            </q-card-section>

            <!-- Divider -->
            <q-separator class="q-my-md" />

            <!-- Registro -->
            <q-card-section class="text-center">
              <p class="text-grey-7 q-mb-none">
                Não tem uma conta?
                <q-btn
                  flat
                  dense
                  color="primary"
                  label="Criar conta"
                  @click="handleRegister"
                  class="text-weight-bold"
                />
              </p>
            </q-card-section>
          </q-card>

          <!-- Footer -->
          <div class="text-center q-mt-md">
            <p class="text-grey-6 text-caption">
              © {{ new Date().getFullYear() }} Plataforma Imobiliária. Um produto da <a href="https://marrar.co.mz" target="__blank" style="text-decoration: none;">Marrar, LDA</a>.
            </p>
          </div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script setup>
import { ref } from 'vue'
import { useQuasar } from 'quasar'
import router from '@/router'
import store from '@/vuex/store'
import Swal from 'sweetalert2'
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";

const auth = getAuth();


// eslint-disable-next-line no-unused-vars
const $q = useQuasar()

const form = ref({
  email: '',
  password: ''
})

const errors = ref({
  email: '',
  password: ''
})

const showPassword = ref(false)
const rememberMe = ref(false)
const loading = ref(false)


const loginWithGoogle = async () => {
  loading.value = true
  try {
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);
    const credential = GoogleAuthProvider.credentialFromResult(result);
    // console.log(credential)
    // console.log(result.idToken)
    const user = result.user;
    const res = await store.dispatch('auth/loginWithGoogle', credential.accessToken)
    sessionStorage.setItem('token', res.access_token)
    console.log('Google Sign-In bem-sucedido:', user);
    router.push('/imoveis')
    loading.value = false
    // Aqui você pode redirecionar o usuário ou armazenar as informações necessárias
  } catch (error) {
    loading.value = false
    console.error('Erro no Google Sign-In:', error);
    Swal.fire({
      icon: 'error',
      title: 'Erro no Google Sign-In',
      text: 'Ocorreu um erro ao tentar fazer login com o Google. Por favor, tente novamente.'
    });
  }
};

const handleLogin = async () => {
  loading.value = true
  errors.value = { email: '', password: '' }

  try {
   
    const res = await store.dispatch('auth/login', {
      email: form.value.email,
      password: form.value.password
    })
    console.log(res.access_token)
    sessionStorage.setItem('token', res.access_token)
    // console.log('Login bem-sucedido:', store.state.auth.user)
    
      router.push('/imoveis')
    
    
  } catch (error) {
    // console.error('Erro no login:', error)
    Swal.fire({
      icon: 'warning',
      title: 'Erro no login',
      text: 'Credenciais inválidas. Por favor, tente novamente.'
    })
    
    
  } finally {
    loading.value = false
  }
}

const handleForgotPassword = () => {
  router.push({ name: 'ResetPassword' })
  // router.push('/forgot-password')
}

const handleRegister = () => {
  
  router.push({  name: 'AutoRegister' })
}
</script>

<style scoped>
.bg-gradient {
  background: linear-gradient(135deg, #e3f2fd 0%, #ffffff 50%, #e8eaf6 100%);
  min-height: 100vh;
}

.login-container {
  width: 100%;
  max-width: 450px;
  padding: 20px;
}

.login-card {
  border-radius: 16px;
  border: 1px solid #e0e0e0;
}

.shadow-10 {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

@media (max-width: 600px) {
  .login-container {
    max-width: 100%;
  }
}
</style>